
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        showToolBarClose: {
            type: Boolean,
            required: false,
            default: true
        }
    }
});
